import { render, staticRenderFns } from "./PricingDesktop.vue?vue&type=template&id=3fef89c7&scoped=true&"
import script from "./PricingDesktop.vue?vue&type=script&lang=js&"
export * from "./PricingDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef89c7",
  null
  
)

export default component.exports